// Code review - In Progress
// Documentation - In Progress
import { useState } from "react";
import { mainTable } from "../css/Common";
import xls_icon from '../image/xls_icon.png'
import word_icon from '../image/word_icon.png'
import pdf_icon from '../image/pdf_icon.png'
import ppt_icon from '../image/ppt_icon.png'
import img_icon from '../image/img_icon.png'

const DownloadSubmissionPopup = ({ data }) => {
  const attachments = Array.isArray(data) ? data : [];
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    if (extension === "pdf") return url;

    const officeExtensions = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
    if (officeExtensions.includes(extension)) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        url
      )}`;
    }

    return ""; // For txt, zip, rar — handle differently
  };
  const extension = selectedFileUrl?.split(".").pop().toLowerCase();
  const getFileIcon = (extension) => {
    switch (extension) {
      case "pdf":
        return pdf_icon;
      case "xls":
      case "xlsx":
        return xls_icon; // Excel icon
      case "doc":
      case "docx":
        return word_icon; // Word icon
      case "ppt":
      case "pptx":
        return ppt_icon; // PowerPoint icon
      default:
        return img_icon; // Generic file icon
    }
  };
  return (
    <div className="w-full">
      <div className={mainTable.mainContentScreen}>
        <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
          <p className="text-center mb-4 font-semibold">Click to View</p>

          <div className="flex flex-col gap-6 break-words">
            {attachments.map((item, index) => {
              const fileUrl = item.AttachedDocument;
              const fileExtension = fileUrl?.split(".").pop().toLowerCase();

              return (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-start gap-4 text-left"
                >
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedFileUrl(fileUrl);
                      setShowFileModal(true);
                    }}
                    src={getFileIcon(fileExtension)}
                    alt={fileExtension.toUpperCase()}
                    className="w-16 h-16 mx-auto sm:mx-0"
                  />
                  <div className="w-full max-w-full space-y-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2">
                      <p className="font-medium min-w-[150px] break-words text-gray-700">
                        Document Name :
                      </p>
                      <p className="break-words">
                        {decodeURIComponent(item.AttachedDocument?.split("/").pop() || "")}
                      </p>
                    </div>
                    <div className="flex flex-wrap sm:flex-nowrap gap-2">
                      <p className="font-medium min-w-[150px] break-words text-gray-700">
                        Page Number :
                      </p>
                      <p className="break-words">{item.IndicatedPages}</p>
                    </div>
                    <div className="flex flex-wrap sm:flex-nowrap gap-2">
                      <p className="font-medium min-w-[150px] break-words text-gray-700">
                        Comments :
                      </p>
                      <p className="break-words">{item.Comments}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </form>
      </div>

      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {selectedFileUrl ? (
                extension === "pdf" ||
                ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(
                  extension
                ) ? (
                  <iframe
                    src={getViewerUrl(selectedFileUrl)}
                    title="File Viewer"
                    className="w-full h-[80vh] rounded"
                  />
                ) : extension === "txt" ? (
                  <iframe
                    src={selectedFileUrl}
                    title="Text File Viewer"
                    className="w-full h-[80vh] rounded bg-white text-left p-4"
                  />
                ) : ["jpg", "jpeg", "png"].includes(extension) ? (
                  <img
                    src={selectedFileUrl}
                    alt="Preview"
                    className="w-full h-auto max-h-[80vh] object-contain rounded"
                  />
                ) : (
                  <p className="text-center text-gray-600">
                    Preview not available for this file type.
                  </p>
                )
              ) : (
                <p className="text-center text-gray-600">
                  No file selected or file not available.
                </p>
              )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadSubmissionPopup;
